// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLeftSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PLeftSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PLeftSquareOutlined = function PLeftSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLeftSquareOutlinedSvg
  }));
};

PLeftSquareOutlined.displayName = 'PLeftSquareOutlined';
export default React.forwardRef(PLeftSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLeftSquareOutlined.js
// module id = 3486
// module chunks = 0